import { render, staticRenderFns } from "./TermsAndPolicies.vue?vue&type=template&id=43509a0e&scoped=true"
import script from "./TermsAndPolicies.vue?vue&type=script&lang=js"
export * from "./TermsAndPolicies.vue?vue&type=script&lang=js"
import style0 from "./TermsAndPolicies.vue?vue&type=style&index=0&id=43509a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43509a0e",
  null
  
)

export default component.exports